import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { withdrawalsQueries } from '@/services/withdrawals/withdrawals.queries';
import { StatusType } from '@/services/withdrawals/withdrawals.types';
import { useSearch } from '@tanstack/react-router';

const useParams = () => {
  const search = useSearch({ from: '/(app)/configuration-management/withdrawals-setup/' });
  const { page, fetch, sort, q } = search;
  return {
    row: page,
    fetch: fetch ?? 10,
    sort,
    search: q,
  };
};

export const useWithdrawalsSetup = (type: StatusType, enabled: boolean) => {
  const { sort, ...params } = useParams();

  const { data, isFetched, isLoading } = useQuery({
    ...withdrawalsQueries.list(type, params),
    enabled,
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return { withdrawals: data?.data || [], isFetched, isLoading, pagination: data?.meta?.pagination ?? defaultMeta };
};

export const useWithdrawalSetupDetail = (withdrawalId?: string) => {
  const { data, isLoading } = useQuery({
    ...withdrawalsQueries.detail(withdrawalId),
    select: (res) => ({
      ...res,
      data: (({ sno, withdrawalId, ...rest }) => {
        void sno;
        void withdrawalId;
        return {
          ...rest,
          minAmount: rest.minAmount ?? 0,
          maxAmount: rest.maxAmount ?? 0,
          requestingDayFrom: String(rest.requestingDayFrom ?? ''),
          requestingDayTo: String(rest.requestingDayTo ?? ''),
          withdrawableDate: String(rest.withdrawableDate ?? ''),
        };
      })(res.data),
    }),
    enabled: !!withdrawalId,
  });

  return { withdrawalDetail: data?.data, isLoading };
};
